import React, { useEffect, useRef, useState } from "react";
import Input from "../../components/Input/Input";
import styles from "../Pages.module.css";
import Select from "../../components/Select/Select";
import Button from "../../components/Button/Button";
import { baseURL } from "../../components/utils/utils";
import { useFetch } from "../../hooks/useFetch";
import { useAuthContext } from "../../hooks/useAuthContext";
import Table from "../../components/Table/Table";
import SelectObjetos from "../../components/Select/SelectObjetos";
import { useNavigate } from "react-router-dom";

const Itens = () => {
  const navigate = useNavigate();
  // instancia o useFetch de comunicação com API
  const { httpGet: httpProjetos } = useFetch(`${baseURL}/projetos/`);

  const { httpGet: httpModulos } = useFetch(`${baseURL}/modulos/`);

  const { httpGet: httpUsers } = useFetch(`${baseURL}/usuarios/`);

  const { httpGet, httpRequest, setError, loading } = useFetch(
    `${baseURL}/itens/`
  );

  const horRef = useRef();
  const usuRef = useRef();

  const projRef = useRef();
  const gerRef = useRef();
  const praRef = useRef();
  const statusRef = useRef();
  const [formError, setFormError] = useState("");
  const [isActive, setActive] = useState(false);

  //trata erros de formulário
  const [horasError, setHorasError] = useState("");
  const [prazoError, setPrazoError] = useState("");
  const [projError, setProjError] = useState("");
  const [moduloError, setModuloError] = useState("");
  const [statusError, setStatusError] = useState("");
  const [userError, setUserError] = useState("");

  const { user } = useAuthContext();
  const [data, setData] = useState([]);
  const [dadosTabela, setTabela] = useState([]);

  const head = ["Id", "Usuario", "Horas", "Status", "Prazo", "Descrição"];
  const statusOptions = [
    "...",
    "Pendente",
    "Em andamento",
    "Concluído",
    "Atrasado"
  ];

  //chaves estrangeiras

  const [moduloList, setModuloList] = useState([]);
  const [projetoList, setProjList] = useState([]);
  const [usersList, setUsersList] = useState([]);

  //atributos
  const [item, setItem] = useState([]);
  const [ItemId, setId] = useState(0);
  const [fk_ProjId, setProjId] = useState(0);
  const [fk_ModId, setModId] = useState(0);
  const [fk_UsuId, setUsuId] = useState(0);
  const [ItemHoras, setHoras] = useState(0);
  const [ItemPrazo, setPrazo] = useState(0);
  const [ItemStatus, setStatus] = useState(1);
  const [ItemDes, setDes] = useState("");

  useEffect(() => {
    const getList = async () => {
      if (user && user.token) {
        if (!item.fk_UsuId) {
          setUsuId(user.UsuId);
        }
        const projetos = await httpProjetos(user.token, "listar");
        setProjList(projetos); // Armazena os projetos

        const modulos = await httpModulos(user.token, "listar");
        setModuloList(modulos); // Armazena os modulos

        const usuarios = await httpUsers(user.token, "listar");
        setUsersList(usuarios); // Armazena os usuarios

        const dados = await httpGet(user.token, "listar");
        setData(dados);
        const dadosTabela = objToList(dados);
        dadosTabela && setTabela(dadosTabela);

        //  console.log(dados[0]);
      } else {
        navigate("/login");
      }
    };
    getList();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item, ItemDes]);

  // salva os dados do formulário
  const handleSave = async (e) => {
    e.preventDefault();

    const nItem = validaCampos();

    if (nItem) {
      setUsuId(user.UsuId);
      var endpoint = "inserir";
      if (ItemId > 0) {
        endpoint = `atualizar/${ItemId}`;
      }

      const data = await httpRequest(nItem, user.token, endpoint);

      if (data && data) {
        setItem(data);
        handleCancel();
      }
    }
  };

  const objToList = (dados) => {
    return (
      dados &&
      dados.map((obj) =>
        Object.keys(obj).reduce((acc, key) => {
          if (
            key === "ItemId" ||
            key === "ItemDes" ||
            key === "fk_UsuId" ||
            key === "ItemHoras" ||
            key === "ItemPrazo" ||
            key === "ItemStatus"
          ) {
            acc[key] = obj[key];
          }
          return acc;
        }, {})
      )
    );
  };
  // Carrega os dados do item selecionado no formulário
  const handleClickUpdate = (itemEditing) => {
    const eItem = data.find((item) => item.ItemId === itemEditing.ItemId);

    setId(eItem.ItemId);
    setPrazo(eItem.ItemPrazo);
    setStatus(eItem.ItemStatus); // Atualiza o status selecionado
    setProjId(eItem.fk_ProjId);
    setModId(eItem.fk_ModId);
    setUsuId(eItem.fk_UsuId);
    setHoras(eItem.ItemHoras);
    setDes(eItem.ItemDes);
    setItem(eItem);
    setActive(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  // exclui a informação
  const handleClickdel = async (itemDeleting) => {
    setActive(true);
    if (
      window.confirm(`Tem certeza que deseja excluir o item ${item.ItemDes}?`)
    ) {
      const res = await httpRequest(
        itemDeleting,
        user.token,
        `remover/${itemDeleting.ItemId}`
      );
      // console.log(res);
      if (res.success) {
        alert(`${res.message}`);
        setItem([]);
        handleCancel();
      }
    }
  };

  // valida os campos do formulário
  const validaCampos = () => {
    // Valida o campo Projeto

    if (fk_ProjId === 0) {
      setFormError("Selecione um Projeto.");
      setProjError(true);
      projRef.current.focus(); // Foca no campo Status
      return false;
    }
    // Valida o campo Modulo
    if (fk_ModId === 0) {
      setFormError("Selecione um Módulo.");
      setModuloError(true);
      gerRef.current.focus(); // Foca no campo Status
      return false;
    }

    if (!ItemHoras || isNaN(parseFloat(ItemHoras))) {
      console.log(ItemHoras);
      setFormError("O campo Horas é obrigatório.");
      setHorasError(true);
      horRef.current.focus(); // Foca no campo Nome
      return false;
    }

    if (!ItemPrazo) {
      setFormError("O campo Data é obrigatório.");
      setPrazoError(true);
      praRef.current.focus(); // Foca no campo data
      return false;
    }

    // Valida o campo Status
    if (ItemStatus === 0) {
      setFormError("O campo Status é obrigatório.");
      setStatusError(true);
      statusRef.current.focus(); // Foca no campo Status
      return false;
    }

    const nItem = {
      ItemId,
      ItemStatus,
      ItemHoras,
      ItemPrazo,
      fk_ProjId,
      fk_ModId,
      fk_UsuId,
      ItemDes: setDescricao()
    };
    console.log(nItem);
    return nItem;
  };

  const setDescricao = () => {
    let descricao = ItemDes;

    if (fk_ProjId && fk_ProjId > 0 && fk_ModId && fk_ModId > 0) {
      const projeto = projetoList.find(
        (proj) => proj.ProjId === Number(fk_ProjId)
      );

      descricao = projeto.ProjNome;
      const modulo = moduloList.find((mod) => mod.ModId === Number(fk_ModId));
      descricao = `${descricao} - ${modulo.ModNome}`;
      setDes(descricao);
      console.log(descricao);
      return descricao;
    }
    return false;
    //return descricao;
  };

  //cancela a operação e limpa os campos
  const handleCancel = () => {
    setData([]);
    setTabela([]);
    setActive(false); // Desativa o botão "Cancelar"
    setUsuId(user.UsuId);
    setId(0);
    setPrazo(0);
    setHoras(0);
    setStatus(1);
    setProjId(0);
    setModId(0);
    handleCleanError();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const handleCleanError = () => {
    setFormError(false);
    setError(false);
    setHorasError(false);
    setProjError(false);
    setModuloError(false);
    setUserError(false);
    setStatusError(false);
    setPrazoError(false);
  };
  //Selects:
  const handleSelectProjeto = (e) => {
    handleCleanError();
    setProjId(0);

    if (e.target.value > 0) {
      setProjId(e.target.value);
    }
  };
  const handleSelectModulo = (e) => {
    handleCleanError();
    setModId(0);
    if (e.target.value > 0) {
      setModId(e.target.value);
    }
  };
  const handleSelectUsers = (e) => {
    handleCleanError();
    setUsuId(0);
    if (e.target.value > 0) {
      setUsuId(e.target.value);
    }
  };

  const handleSelectStatus = (e) => {
    handleCleanError();
    setStatus(0);
    if (e.target.value > 0) {
      setStatus(e.target.value);
    }
  };
  const exibeAlerta = (alerta) => {
    alert(alerta);
  };
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Demandas</h1>
      <div className={styles.card}>
        {/*error && <p className={styles.error}>{error}</p>*/}
        {formError && <p className={styles.error}>{formError}</p>}
        <SelectObjetos
          ref={usuRef} // Referência para o campo Status
          label="Usuário"
          id="fk_UsuId"
          options={usersList}
          value={
            fk_UsuId && fk_UsuId
              ? fk_UsuId
              : user && user.UsuId
              ? user.UsuId
              : 0
          }
          onChange={(e) => handleSelectUsers(e)}
          valueKey="UsuId"
          labelKey="UsuNome"
          disabled={false}
          hasError={userError}
        />
        <SelectObjetos
          ref={projRef} // Referência para o campo Status
          label="Projeto"
          id="fk_ProjId"
          options={projetoList}
          value={fk_ProjId}
          onChange={(e) => {
            handleSelectProjeto(e);
          }}
          hasError={projError}
          valueKey="ProjId"
          labelKey="ProjNome"
        />
        <SelectObjetos
          ref={gerRef} // Referência para o campo Status
          label="Módulo"
          id="fk_ModId"
          options={moduloList}
          value={fk_ModId}
          onChange={(e) => handleSelectModulo(e)}
          hasError={moduloError}
          valueKey="ModId"
          labelKey="ModNome"
        />
        <Input
          ref={horRef} // Referência para o campo Nome
          label="Horas"
          id="ItenHoras"
          type="text"
          value={(ItemHoras && ItemHoras) || ""}
          onChange={(e) => {
            setHoras(e.target.value);
            handleCleanError();
            setActive(true);
          }}
          hasError={horasError} // Aplica a classe de erro se houver erro no nome
        />
        <Input
          ref={praRef} // Referência para o campo Nome
          label="Prazo"
          id="ItenPrazo"
          type="date"
          value={(ItemPrazo && ItemPrazo) || ""}
          hasError={prazoError} // Aplica a classe de erro se houver erro no nome
          onChange={(e) => {
            setPrazo(e.target.value);
            handleCleanError();
            setActive(true);
          }}
        />
        <Select
          ref={statusRef} // Referência para o campo Status
          label="Status"
          id="ItemStatus"
          options={statusOptions} // Passa o array de status
          value={ItemStatus} // Usa o estado do status selecionado
          onChange={(e) => handleSelectStatus(e)} // Atualiza o status ao selecionar
          hasError={statusError} // Aplica a classe de erro se houver erro no status
        />
        {loading && <p className={styles.loading}>Carregando...</p>}
        {formError && alert(formError)}
        <Button texto="Salvar" onClick={handleSave} active={true} />
        <Button texto="Cancelar" onClick={handleCancel} active={isActive} />

        <Table
          head={head}
          status={statusOptions}
          data={dadosTabela && dadosTabela}
          onClickUpdate={handleClickUpdate}
          onClickDel={handleClickdel}
          listas={{
            fk_UsuId: usersList
          }}
          isMaster={true}
        />
      </div>
    </div>
  );
};

export default Itens;
